const BUSINESS_TRAVELLER_ESTIMATED_TRAVEL_SPEND_PER_ANNUM_OPTIONS: Array<[App.BusinessTraveller.EstimatedTravelSpendOptions, string]> = [
  ['up_to_10k', 'Up to $10k'],
  ['10k_to_100k', '$10k - $100k'],
  ['100k_to_500k', '$100k - $500k'],
  ['over_500k', 'Over $500k'],
]

export default BUSINESS_TRAVELLER_ESTIMATED_TRAVEL_SPEND_PER_ANNUM_OPTIONS
